<template>
  <router-link :to="location" class="text-nowrap">
    {{ text }}
  </router-link>
</template>

<script>
export default {
  name: 'DerbyRaceLink',

  props: {
    raceId: {
      type: Number,
      required: true
    },
  },

  computed: {
    /** @returns {Object} */
    location() {
      return {
        name: 'derby_race',
        params: {
          raceId: this.raceId,
        },
      };
    },

    /** @return {string} */
    text() {
      const raceIdStr = this.raceId.toString();
      return 'заезд ' + raceIdStr;
    },
  },
}
</script>
